import { useEffect, useState } from "react";
import { agent } from "../utils/agent";

const usePaginatedData = (apiUrl, { limit = 10, enabled = true }) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially.
  const [params, setParams] = useState({ limit });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    if (!enabled) return; // Prevent API calls when disabled.
    setLoading(true);
    setError(null);

    try {
      const response = await agent.get(apiUrl, {
        params: { ...params, page: currentPage },
      });

      // Extract totalPages and data from response.
      setData(response.data.data.data || []); // Safely access nested `data`.
      setTotalPages(response.data.data.last_page || 1); // Use `last_page` from API.
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [apiUrl, params, currentPage, enabled]);

  const handleSearch = (searchKey, searchValue) => {
    setParams((prev) => ({
      ...prev,
      [searchKey]: searchValue,
    }));
    setCurrentPage(1); // Reset to page 1 after a search.
  };

  const handleSort = (sortBy, sortOrder) => {
    setParams((prev) => ({
      ...prev,
      sort: `${sortBy}%${sortOrder}`,
    }));
    setCurrentPage(1); // Reset to page 1 after sorting.
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return {
    data,
    currentPage,
    totalPages, // This now reflects `last_page` from the API.
    loading,
    error,
    handleSearch,
    handleSort,
    handlePageChange,
  };
};

export default usePaginatedData;
